(function () {
  var KEY = 'ls-size-system';
  function saved() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function apply(sys) {
    document.querySelectorAll('.ls-sizes').forEach(function (fs) {
      if (sys) fs.setAttribute('data-ls-sz', sys);
      var cur = fs.getAttribute('data-ls-sz');
      fs.querySelectorAll('[data-ls-sz-set]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.lsSzSet === cur ? 'true' : 'false'); });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ls-sz-set]');
    if (!b) return;
    e.preventDefault();
    try { sessionStorage.setItem(KEY, b.dataset.lsSzSet); } catch (err) {}
    apply(b.dataset.lsSzSet);
  });

  var sizeChosen = false;
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.ls-sizes')) sizeChosen = true; });

  function setupSticky() {
    var bar = document.querySelector('[data-ls-sticky]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var sid = bar.dataset.section;
    var form = document.getElementById('product-form-' + sid);
    var btn = bar.querySelector('[data-ls-sticky-btn]');
    function mainBtn() { return form && form.querySelector('[type="submit"]'); }
    function label() {
      var mb = mainBtn();
      if (!sizeChosen && document.querySelector('.ls-sizes')) { btn.textContent = 'Choose your size'; return; }
      btn.textContent = mb && mb.disabled ? 'Sold out' : 'Add to cart';
    }
    btn.addEventListener('click', function () {
      var sizes = document.querySelector('.ls-sizes');
      if (!sizeChosen && sizes) { sizes.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var mb = mainBtn(); if (mb && !mb.disabled) mb.click();
    });
    document.addEventListener('change', function () { setTimeout(label, 50); });
    var target = mainBtn();
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.hidden = !off;
      label();
    }).observe(target);
    var price = bar.querySelector('[data-ls-sticky-price]');
    new MutationObserver(function () {
      var p = document.querySelector('#price-' + sid + ' .price-item--last, #price-' + sid + ' .price-item--regular');
      if (p && price) price.textContent = p.textContent.trim();
    }).observe(document.getElementById('price-' + sid) || document.body, { childList: true, subtree: true });
  }

  function init() { apply(saved()); setupSticky(); }
  init();
  new MutationObserver(function () { apply(saved()); }).observe(document.documentElement, { childList: true, subtree: true });
})();
